"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class AlertClient extends authenticated_client_1.AuthenticatedClient {
    getAll(projectId, order) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `/v1/projects/${projectId}/users/me/alerts`;
            if (order) {
                url += url.includes('?') ? `&order=${order}` : `?order=${order}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getAllWithShared(projectId, order) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `/v1/projects/${projectId}/users/me/alerts-with-shared`;
            if (order) {
                url += url.includes('?') ? `&order=${order}` : `?order=${order}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getCount(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/alerts?fields=id`);
            return response.payload && response.payload.length;
        });
    }
    getUnseenCount(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/alerts/unseen`);
            return response.payload;
        });
    }
    get(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/alerts/${id}`);
            return response.payload;
        });
    }
    create(projectId, alert) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/alerts`, alert);
            return response.payload;
        });
    }
    update(projectId, id, alert) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/alerts/${id}`, alert);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/projects/${projectId}/users/me/alerts/${id}`);
        });
    }
    setSeen(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/users/me/alerts/seen`);
        });
    }
    share(projectId, id, alertShared) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/alerts/${id}/share`, alertShared);
            return response.payload || [];
        });
    }
    dismissShare(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/users/me/alerts/${id}/dismiss-share`);
        });
    }
    getNotifications(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/notifications`);
            return response.payload || [];
        });
    }
    addNotificationFeedback(projectId, notificationId, feedback) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/notifications/${notificationId}/feedback`, feedback);
            return response.payload;
        });
    }
    getUnseenNotificationsCount(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/notifications/count?filter={"isNew": "true"}`);
            return response.payload;
        });
    }
    setNotificationsSeen(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/users/me/notifications/seen`);
        });
    }
}
exports.AlertClient = AlertClient;
//# sourceMappingURL=alert.client.js.map